<template>
  <b-button variant="primary" @click="verifyIdentity">
    Verificar Identidad Mediante Clave &Uacute;nica
  </b-button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'VerifyIdentityExternal',
  computed: {
    token() {
      const { token } = this.$route.params;
      return token;
    },
  },
  methods: {
    verifyIdentity() {
      const env = process.env.VUE_APP_AMBIENTE;
      const callback = this.fixedEncodeURIComponent(
        `https://${this.getBasePath()}/${this.getAmbit()}/firma-externo/validacion/${this.token}`
      );
      const url = `https://api.febos.cl/${env}/v2/aprobaciones/externas/firma/enrrolamiento?`
        + `urlCallback=${callback}?status=ok&idProceso=&urlCallbackError=${callback}?status=error&idProceso=&Authorization=${this.token}`;
      window.location.href = url;
    },
    fixedEncodeURIComponent(str) {
      return encodeURIComponent(str)
        .replace(/[!'()]/g, escape)
        .replace(/\*/g, '%2A');
    },
    getAmbit() {
      const options = /cloud|proveedores|cliente/i;
      const defaultAmbit = 'cloud';
      try {
        const parts = window.location.href
          .replace('https://', '')
          .replace('http://', '')
          .split('/');
        if (parts[0].includes('localhost')) {
          return parts[2].match(options) ? parts[2] : defaultAmbit;
        }
        return parts[3].match(options) ? parts[3] : defaultAmbit;
      } catch (e) {
        return defaultAmbit;
      }
    },
    getBasePath() {
      const resultados = window.location.href
        .replace('https://', '')
        .replace('http://', '')
        .split('/');
      return resultados != null && resultados.length >= 0 ? resultados[0] : '';
    }
  }
};
</script>
